/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/media-has-caption */
/** @jsx jsx */
import { jsx, Styled } from 'theme-ui';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BackgroundFrame, Container } from './hero-search-masthead-css';
import SearchAnimatedIntro from '../search/search-animated-intro';

export default class HeroSearchMasthead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countdown: 1,
      nextFrameID: 0,
      prevFrameID: 5,
    };
  }

  componentDidMount() {
    this.intervalId = setInterval(this.timer.bind(this), 1000);
    const initialFrame = document.getElementById('masthead-carousel-'+this.state.nextFrameID);
    // console.log(initialFrame);
  }

  timer() {
    this.setState({
      countdown: this.state.countdown - 1, // One second down in the timer
    });

    // If timer is zero, reset timer and increment the frame ID
    // If the frame ID is beyond the maxiumum number of frames,
    // reset the frame ID to the first frame in the index (zero)
    if (this.state.countdown < 1) {
      // clearInterval(this.intervalId);
      this.setState({
        countdown: 3,
        nextFrameID: this.state.nextFrameID + 1,
        prevFrameID: this.state.prevFrameID + 1,
      });
      if (this.state.nextFrameID > 5) {
        this.setState({
          nextFrameID: 0,
        });
      }
      if (this.state.prevFrameID > 5) {
        this.setState({
          prevFrameID: 0,
        });
      }
      const currentFrame = document.getElementById('masthead-carousel-'+this.state.nextFrameID);
      const previousFrame = document.getElementById('masthead-carousel-'+(this.state.prevFrameID));
      // console.log(currentFrame);
      // console.log(previousFrame);
      currentFrame.style.opacity = 1;
      currentFrame.style.transition = 'opacity 1000ms';
      currentFrame.style.transitionDelay = 0;
      previousFrame.style.opacity = 0;
      previousFrame.style.transition = 'opacity 1000ms';
      previousFrame.style.transitionDelay = '1000ms';
    }
  }

  render() {
    const { backgroundImageAddUpTo6Frames } = this.props;
    const nextFrameID = 'masthead-carousel-';

    return (
      <>
        <div
          sx={{
            height: '530px',
            // animation: `${BackgroundFade} 10s linear infinite alternate both`,
            color: 'PrimaryBrightBlue',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundColor: 'PrimaryDarkBlue',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <SearchAnimatedIntro
            introText={['Hello.<br/>', 'What can we help you find today?']}
            placeholders={['Logos', 'Templates', 'Merchandise', 'Message Repository', 'Event Request', 'Speaking Request ', 'Event Calendar', 'Email Signature', 'Business Cards', 'Brand Guidelines', 'Brand Approval', 'Image Download']}
          />
          {backgroundImageAddUpTo6Frames && (
            <>
              {backgroundImageAddUpTo6Frames.map(({ file }, index) => (
                // <BackgroundFrame
                //   key={index}
                //   id={nextFrameID + index}
                //   backgroundImage={file.url}
                //   frameIndex={index}
                // >
                //   Background file:
                //   {file.url}
                //   <Container
                //     testvar={index}
                //     sx={{
                //       pt: `calc(35 * ${index}px)`,
                //     }}
                //   >
                //     FRAME {index}
                //   </Container>
                // </BackgroundFrame>
                <BackgroundFrame
                  key={index}
                  id={nextFrameID + index}
                  backgroundImage={file.url}
                  frameIndex={index}
                />
              ))}
            </>
          )}
        </div>
      </>
    );
  }
}

HeroSearchMasthead.propTypes = {
  backgroundImageAddUpTo6Frames: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  })).isRequired,
};
